import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useCollection } from '@nandorojo/swr-firestore';
import { Inotification } from '@typings/notification/notification.interface';
import { CollectionPath } from '@typings/collections.enum';
import { currentUserIDState } from '@atom/setting/user';
import { unreadNotificationsState } from '@atom/setting/notification';

/**
 * Firestore `users/{uid}/notifications` (is_seen === false)를 단일 구독하고
 * 결과를 unreadNotificationsState atom에 동기화한다.
 *
 * Main.tsx 같은 최상위에서 한 번만 호출하면
 * NotificationBtn, NotificationBrowserAlert 등 하위 컴포넌트는
 * atom만 읽어서 Firestore 리스너 중복을 방지한다.
 */
export function useUnreadNotifications() {
  const currentUserId = useRecoilValue(currentUserIDState);
  const collectionPath = currentUserId
    ? `${CollectionPath.USERS}/${currentUserId}/${CollectionPath.NOTIFICATIONS}`
    : null;

  const setUnreadList = useSetRecoilState(unreadNotificationsState);

  const { data } = useCollection<Inotification>(collectionPath, {
    where: ['is_seen', '==', false],
    listen: true,
  });

  useEffect(() => {
    setUnreadList(data ?? []);
  }, [data, setUnreadList]);
}
